import { Pipe, PipeTransform } from "@angular/core";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  MediaViewModel,
} from "src/domain/client";

@Pipe({
  name: "media",
  pure: true,
})
export class MediaPipe implements PipeTransform {
  transform(
    media: MediaViewModel[] | null | undefined,
    mediaCategoryTypeName: string,
    mediaTypeName: string,
  ): string {
    const m = media?.find(
      (_) =>
        _.mediaCategoryTypeName === mediaCategoryTypeName &&
        _.mediaTypeName === mediaTypeName,
    );

    if (!m) {
      return "";
    }

    switch (m.mediaTypeName) {
      case MediaTypeNameEnum.Text:
        switch (m.mediaCategoryTypeName) {
          case MediaCategoryTypeNameEnum.Title:
          case MediaCategoryTypeNameEnum.Caption:
          case MediaCategoryTypeNameEnum.Ingress:
          case MediaCategoryTypeNameEnum.Body:
          case MediaCategoryTypeNameEnum.Technical:
          case MediaCategoryTypeNameEnum.ProductName:
          case MediaCategoryTypeNameEnum.Description:
            return m.content ?? "";
          default:
            return "";
        }
      case MediaTypeNameEnum.Image:
        switch (m.mediaCategoryTypeName) {
          case MediaCategoryTypeNameEnum.Hero:
          case MediaCategoryTypeNameEnum.L:
          case MediaCategoryTypeNameEnum.M:
          case MediaCategoryTypeNameEnum.S:
          case MediaCategoryTypeNameEnum.ImageNameLarge:
          case MediaCategoryTypeNameEnum.ImageNameMedium:
          case MediaCategoryTypeNameEnum.ImageNameSmall:
            return m.url ?? "";
          default:
            return "";
        }
      case MediaTypeNameEnum.Button:
        switch (m.mediaCategoryTypeName) {
          case MediaCategoryTypeNameEnum.Technical:
            return m.content ?? "";
          default:
            return "";
        }
      case MediaTypeNameEnum.HTML:
        switch (m.mediaCategoryTypeName) {
          case MediaCategoryTypeNameEnum.Body:
          case MediaCategoryTypeNameEnum.Technical:
            return m.content ?? "";
          default:
            return "";
        }
      case MediaTypeNameEnum.Link:
        switch (m.mediaCategoryTypeName) {
          case MediaCategoryTypeNameEnum.Technical:
          case MediaCategoryTypeNameEnum.HREF:
            return m.content ?? "";
          default:
            return "";
        }
      case MediaTypeNameEnum.Video:
        switch (m.mediaCategoryTypeName) {
          case MediaCategoryTypeNameEnum.Technical:
            return m.content ?? "";
          default:
            return "";
        }
      default:
        return "";
    }
  }
}
